import { Divider, Space } from 'component/Space'
import { Vertical } from 'component/Vertical'
import { observer } from 'mobx-react-lite'
import { ItemPane } from 'page/BasicInferenceScreen/ItemPane'
import { Tele2Button } from 'page/BasicInferenceScreen/Tele2Button'
import { Fragment } from 'react'
import { opt } from 'store/opt'
import { store } from 'store/store'
import css from './ItemsPane.module.scss'

export const ItemsPane = observer(() => {
  const { carousel, extend } = store.carousel
  const items = carousel.item?.items ?? []
  const shape = items.length > 1

  return <Vertical className={css.pane} wide oh>
    {!extend && items.map((item, index) => (<Fragment key={index}>
      {index > 0 && <Space pad={[0, 16]}>
        <Divider secondary />
      </Space>}
      <ItemPane item={item} shape={shape} />
    </Fragment>))}
    {!extend && opt.t2 && <Tele2Button />}
    {extend && <ItemPane item={extend} shape={shape} full />}
  </Vertical>
})
